export const LABELS = {
    /**Titles */
    Os:"Os",
    ScriptManagmentTitle: "Deployment Script Management",
    Contract:"Contracts",
    CloudEnviroment:"Cloud Environment",
    CloudInitManagment:"Vm Configuration Management",
    VmConfiguration:"Vm Configuration",
    CloudInit:"Cloud Init",
    PostProviosing:"Post Provisioning",
    AddPost:"Add Posts",
    Commands:"Commands",
    Policies:"Policies",
    AddPolicies:"Add Policies",
    Rules:"Rules",
    VMTemplate:"VM Template ",
    DecommissionManagment:"Decommission Management",
    CloudManagment:"Cloud Management",
    CloudEnviromentManagment:"Cloud Environment Management",
    VMTemplateManagment:"VM Template Management",
    ScriptManagmentTitleTabs: "script management tabs",
    DeploymentScriptIDTitle: "DeploymentScriptID",
    ActiveScripts: "Active Scripts",
    InactiveScripts: "Inactive Scripts",
    ConfigFiles:"Config File",
    AddConfig:"Add Config File",
    ConfigFilesList:"Config File List",
    Provider: "Provider",
    Title: "Title",
    Script: "Script",
    Location: "Location",
    DateAdded: "Date Added",
    ProvisioningDate:"Provisioning Date",
    DecommisioningDate:"Decommissioning Date",
    Notes: "Notes",
    Actions: "Actions",
    NoData:"No data Available",
    Nº: "Nº",
    DeploymentScriptID: "deploymentScriptID",
    DataCenterDescription:"DataCenter Description",
    Name:"Name",
    NameRequired:"Name is Required",
    DataCenterName:"DataCenter Name",
    DataCenterRequired:"DataCenter Name is Required",
    LocationRequired:"Location is Required",
    DeploymentScript:" Deployment Scripts",
    CloudProvider: "cloudProvider",
    CloudProviderWithSpace:"Cloud Provider",
    ContractID:"Contract",
    Iac:"Iac",
    AuthenticationconfigRequired:"Authentication Config is required",
    IacRequired: "Iac is Required",
    Id: "id",
    ASC: "asc",
    Desc: "desc",
    ArrowUp: "▲",
    ArrowDown: "▼",
    NoScriptAvailable: "scripts available.",
    NO: "NO",
    Active: "Active",
    Inactive: "Inactive",
    Add: "Add",
    AddCloud:"Add Cloud",
    Status: "Status",
    Description: "Description",
    DatacenterScription:"Datacenter Description",
    EditScript: "Edit Script",
    AddScript: "Add Script",
    AddProvider: "Add Provider",
    AuthenConfig:"Authentication Config",
    JsonAlreadyExits:"JSON already exists – enter new JSON to replace it, or leave blank",
    InvalidJsonFormat: "Invalid JSON format",
    EnterValidJsonFormat:"Enter valid JSON here",
    AddCloudEnvironment: "Add Cloud Environment",
    VmTemplate: "VM Template",
     AddVmTemplate: "Add VMTemplate",
    Update: "Update",
    Save: "Save",
    Submit:"Submit",
    DragDropFileHereOrClickHere: "Drag and drop a file here,",
    OrClickHere:"or click to select file",
    DropFileHere: "Drop the files here ...",
    LogOut: "Logout",
    Profile: "Profile",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Label: "label",
    Settings: "Settings",
    Sim:"sim",
    Nao:"Não",
    DetailView:"Detail View",
    Search:"Search",
    Filters:"Filters",
    ClearAll:"Clear ALL",
    ScriptIdDonotExist:"Script item ID does not exist",
    TitleDecommission:"Decommission Process.",
    Decommision:"Decommission",
    ResourcesDecommission:"Resources for Decommissioning",
    /*Required*/
    ScriptRequired:"Script",
    NoTemplatesAvailable:"No Templates Available ",
    ProvisioningTemplate:"Provisioning Template",
    VmProvisioning:"Vm Post Provisioning",
    VmPolicy:"Vm Policy",
    SelectOs:"Select OS",
    CpuCore:"Cpu Core",
    CpuCoreValue:"Cpu Core-value",
    Ram:"Ram",
    RamValue:"Ram-value",
    Storage:"Storage",
    StorageValue:"Storage-Value",
    DiskSize:"Disk Size (GB)",
    Azure:"azure",
    ScriptNoDataAvailable:"There are no Deployment Scripts to show",
    DeleteVmTemplate:"Delete Vm Template",
    TemplateDoesNotExist: "Template does not exist",
    DeletingVmTemplate:"Deleting VmTemplate",
    CloudProvisionerTemplateManagement: "Cloud Provisioner Template Management",
    AddCloudProvisionerTemplate: "Add Cloud Provisioner Template",
    ProviderType: "Provider Type",
    AzureVmSize: "Azure VM Size",
    AzureImageUrn: "Azure Image URN",
    AzureLocation: "Azure Location",
    AzureResourceGroup: "Azure Resource Group",
    AzureAppPorts: "Azure App Ports",
    AwsRegion: "AWS Region",
    AwsInstanceTypes: "AWS Instance Types",
    AwsAmiIds: "AWS AMI IDs",
    AwsAppPorts: "AWS App Ports",
    AwsInstanceType: "AWS Instance Type",
    LocationRegion: "Location / Region",
    SizesInstanceTypes: "Sizes / Instance Types",
}